import type {
  FieldItemTypeLinkWithEntityEntityFragment,
  ParagraphTeaserFragment,
  TeaserNodeFragment,
} from '#graphql-operations'
import type { TeaserProps } from '~/components/Teaser/types'

export function buildTeaserProps(
  props: ParagraphTeaserFragment | TeaserNodeFragment,
): TeaserProps | null {
  if ('logoTheme' in props) {
    return {
      title: props.teaserTitle,
      tagline: props.teaserTagline,
      text: props.teaserText,
      url: props.url?.path,
      media: props.teaserImage,
      nid: props.id,
    }
  } else if ('link' in props) {
    const url = props.link?.uri?.path

    const entity: FieldItemTypeLinkWithEntityEntityFragment | null = (() => {
      const uri = props.link?.uri
      if (!uri) {
        return null
      }

      if (!('entity' in uri) || !uri.entity) {
        return null
      }

      if (!('teaserTitle' in uri.entity)) {
        return null
      }

      return uri.entity
    })()

    const nid = entity && 'id' in entity ? entity.id : undefined
    const logoTheme = entity && 'logoTheme' in entity ? entity.logoTheme : null

    return {
      title: props.title || entity?.teaserTitle,
      tagline: props.tagline || entity?.teaserTagline || logoTheme?.top,
      text: props.text || entity?.teaserText,
      url,
      linkTitle: props.link?.title,
      media: props.image || entity?.teaserImage,
      nid,
      entity,
      // @ts-expect-error status exists on all entities
      isPublished: entity?.status || false,
    }
  }

  return null
}
